import { markdownToHtml } from "../utils"

const mdHtml = {
  bind: function (el, binding) {
    el.innerHTML = markdownToHtml(binding.value)
  },

  update: function (el, binding) {
    el.innerHTML = markdownToHtml(binding.value)
  }
}

const pin = {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
}

export {
  pin,
  mdHtml
}